import { WidgetBase } from '../';
import { Helper } from '../../common/';

export class HorizontalBarChartWidget extends WidgetBase {
    guid: string;
    name = 'Bar chart';
    type = 'horizontalBarChart';

    constructor() {
        super();
        this.guid = Helper.getGuid();
    }
}